import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    setEnderecos: ["payload"],
    setAtivo: ["payload"],
    setMotoristas: ["payload"],
    setRotas: ["payload"],
    setConfigMotor: ["payload"],
    setConfigRota: ["payload"],
});

export const INITIAL_STATE = {
    motoristas: [],
    rotas: [],
    columns: [],
    ativo: true,
};

const setConfigMotor = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        motoristas: action.payload,
    };
};

const setConfigRota = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        rotas: action.payload,
    };
};

const setMotoristas = (state = INITIAL_STATE, action) => {
    if (
        state.motoristas.length === 0 ||
        action.payload.length !== state.motoristas.length
    ) {
        return {
            ...state,
            motoristas: action.payload,
        };
    } else {
        let motors = state.motoristas.map((motorista) => {
            let novo = action.payload.filter(
                (moto) => moto.cpf === motorista.cpf
            )[0];
            return {
                ...motorista,
                lat: novo.lat,
                lng: novo.lng,
                dt_rastreio: novo.dt_rastreio,
                status: novo.status,
                type: novo.type,
                active: novo.active,
            };
        });
        return {
            ...state,
            motoristas: motors,
        };
    }
};

const setRotas = (state = INITIAL_STATE, action) => {
    if (
        state.rotas.length === 0 ||
        action.payload.length !== state.rotas.length
    ) {
        return {
            ...state,
            rotas: action.payload,
        };
    } else {
        let motors = state.rotas.map((rota) => {
            let novo = action.payload.filter(
                (moto) => moto.cpf === rota.cpf
            )[0];
            return {
                ...rota,
                lat: novo.lat,
                lng: novo.lng,
                dt_rastreio: novo.dt_rastreio,
                status: novo.status,
                type: novo.type,
                active: novo.active,
            };
        });
        return {
            ...state,
            rotas: motors,
        };
    }
};

const setEnderecos = (state = INITIAL_STATE, action) => {
    let array = state.columns.filter(
        (colum) => colum.cpf === action.payload.cpf
    );

    if (state.columns.length === 0 || array.length === 0) {
        return {
            ...state,
            columns: [...state.columns, action.payload],
        };
    } else {
        let aux = state.columns.map((colum) => {
            if (colum.cpf === action.payload.cpf) {
                return { ...action.payload };
            } else {
                return { ...colum };
            }
        });
        return {
            ...state,
            columns: aux,
        };
    }
};

const setAtivo = (state = INITIAL_STATE, action) => ({
    ...state,
    ativo: !state.ativo,
});

export default createReducer(INITIAL_STATE, {
    [Types.SET_ENDERECOS]: setEnderecos,
    [Types.SET_ATIVO]: setAtivo,
    [Types.SET_MOTORISTAS]: setMotoristas,
    [Types.SET_ROTAS]: setRotas,
    [Types.SET_CONFIG_MOTOR]: setConfigMotor,
    [Types.SET_CONFIG_ROTA]: setConfigRota,
});
